import React from 'react';
import { Dot } from 'recharts';
const HollowCircularDotDefault = _ref => {
  let {
    cx,
    cy,
    color,
    stroke
  } = _ref;
  const radius = 3;
  return /*#__PURE__*/React.createElement(Dot, {
    cx: cx,
    cy: cy,
    r: radius,
    fill: stroke !== color ? color : '#fff',
    stroke: color,
    strokeWidth: 2
  });
};
export default HollowCircularDotDefault;